/**
 * Reducer for activate/deactivate layers
 *
 * @param activeLayers
 * @param action
 * @returns {*[]}
 */
import {Base64} from 'js-base64';
import {setDynamicUrlLayers} from '../config/dynamicUrlHelper';
import {pushGtmDataLayer, pushGtmActivateLayer} from '../config/gtm';

export const activeLayersReducer = (activeLayers = [], action) => {
    /* make a copy of the existing array - PREVENT DIRECT MUTATION */
    let newActiveLayers = activeLayers.slice();
    if (action.type === 'LAYER_ACTIVATED') {
        /* activate layers */
        /* if layer is activated, remove layer*/
        if (newActiveLayers.includes(action.payload)) {
            newActiveLayers.splice(newActiveLayers.indexOf(action.payload), 1);
        } else {
            /* if layer is radio, remove layer that has the same group_id*/
            if (action.payload.is_radio) {
                newActiveLayers.forEach(function(layer, index){
                    if(action.payload.group_id === layer.group_id) {
                        newActiveLayers.splice(newActiveLayers.indexOf(layer), 1);
                    }
                })
            }
            /* reset hide and opacity status */
            action.payload.hide = false;
            action.payload.opacity = 100;

            /* activate layer */
            newActiveLayers.unshift(action.payload);

            /* gtm event processing */
            pushGtmActivateLayer(action.payload);
        }
        // setDynamicUrl(newActiveLayers);
        // return newActiveLayers;
    } else if (action.type === 'SUBLAYER_ACTIVATED') {
        newActiveLayers.forEach((layer, index) => {
            if (layer.id === action.payload.id) {
                layer = action.payload;
            }
        });
        // return newActiveLayers;
    } else if (action.type === 'LAYER_OPACITY_CHANGED') {
        newActiveLayers.forEach((layer, index) => {
            if (layer.id === action.payload.id) {
                layer = action.payload;
            }
        });
        // return newActiveLayers;
    } else if (action.type === 'LAYER_SORTED') {
        /* replace layers array with new sorted layers array */
        newActiveLayers = action.payload;
        // return action.payload;
    } else if (action.type === 'LAYER_HIDE') {
        newActiveLayers.forEach((layer, index) => {
            if (layer.id === action.payload.id) {
                layer = action.payload;
                // layer.hide = layer.hide !== true;
            }
        });
        // return newActiveLayers;
    } else if(action.type === 'DATE_FILTER_APPLIED') {
        newActiveLayers.forEach((layer, index) => {
            if (layer.id === action.payload.layer.id) {
                layer.layer_active.layer_time[0].start_date = action.payload.from;
                layer.layer_active.layer_time[0].end_date = action.payload.to;
                layer.layer_active.layer_time[0].start_date_is_range = 0;
                layer.layer_active.layer_time[0].end_date_is_range = 0;
                if(action.payload.type === 'day') {
                    layer.layer_active.layer_lists.forEach(subLayer => {
                        subLayer.layer_filter = `tanggal >= '${action.payload.from}' and tanggal <= '${action.payload.to}'`;
                    });
                } else if(action.payload.type === 'year') {
                    layer.layer_active.layer_lists.forEach(subLayer => {
                        subLayer.layer_filter = `tahun >= ${action.payload.from} AND tahun <= ${action.payload.to}`;
                    });
                }
            }
        });
        // return newActiveLayers;
    } else if(action.type === 'MITRA_RESTORASI_FILTER_APPLIED') {
        newActiveLayers.forEach((layer, index) => {
            if (layer.id === parseInt(process.env.MIX_MAP_MITRA_RESTORASI_ID)) {
                layer.layer_active.layer_lists.forEach(subLayer => {
                    let filter = subLayer.layer_filter.split('AND')[0];
                    if(action.payload.pelaksana){
                        filter += ` AND pelaksana ='${action.payload.pelaksana}'`;
                    }
                    if(action.payload.pendana){
                        filter += ` AND sumber_dana ='${action.payload.pendana}'`;
                    }
                    subLayer.layer_filter = filter;
                });
            }
        });
        // return newActiveLayers;
    } else if (action.type === 'RESET_LAYERS') {
        /* reset all layers */
        newActiveLayers = [];
        action.payload.map((layerGroup) => {
            layerGroup.layers.map((layer) => {
                if(layer.is_default === 1){
                    newActiveLayers.push(layer);
                }
            })
        })
        // return newActiveLayers;
    } else if(action.type === 'ADD_ADHOC_LAYER') {
        newActiveLayers.unshift(action.payload);
    }
    setDynamicUrlLayers(newActiveLayers);
    return newActiveLayers;
};